<template>
    <faqs-layout>
        <v-layout _faqs-layout>
            <v-container align-center justify-center fill-height>
                <v-layout row wrap>

                    <!-- Header Row: Back & Chat Info -->
                    <v-flex xs12 class="faq-header">
                        <!-- <div class="back-btn" @click="$router.back()">&lt; Back</div> -->
                        <div></div>
                        <div>
                            <h2 class="faq-heading">FAQ’s</h2>
                        </div>

                        <div class="chat-info">
                            <span style="cursor: pointer" @click="$router.push('/contact-us')">
                                Can't find what you're looking for?<br />
                                <strong>Get in touch with us directly.</strong>
                            </span>



                            <!-- <router-link to="/contact-us">
                                <img src="@/assets/img/chat2.png" alt="Chat" class="chat-icon" />
                            </router-link> -->
                        </div>
                    </v-flex>


                    <!-- FAQ Heading -->
                    <!-- <v-flex xs12>
                        <h2 class="faq-heading">FAQ’s</h2>
                    </v-flex> -->

                    <!-- Toggle Buttons -->
                    <v-flex xs12 mb-5>
                        <div class="toggle-buttons">
                            <button :class="{ active: selectedRole === 'parent' }" @click="selectedRole = 'parent'">
                                For Families
                            </button>
                            <button :class="{ active: selectedRole === 'nanny' }" @click="selectedRole = 'nanny'">
                                For NannyGrannies
                            </button>
                        </div>
                    </v-flex>

                    <!-- FAQ Panel -->
                    <v-flex xs12 d-flex justify-center>
                        <v-expansion-panel flat class="app-expansion-panel w--max--800">
                            <v-expansion-panel-content v-for="(item, i) in items" :key="'panel' + item.id">
                                <p slot="header" class="font--medium ma-0 text--black">{{ item.name }}</p>
                                <p class="content-base" v-html="item.description"></p>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-flex>

                </v-layout>
            </v-container>
        </v-layout>
    </faqs-layout>
</template>

<script>
import FaqsLayout from './faqs-layout'

export default {
    name: 'faqs',
    components: { FaqsLayout },
    data() {
        return {
            selectedRole: this.$auth.user().role || 'parent'
        }
    },
    // mounted() {
    //     document.title = "NannyGranny FAQs – Everything You Need To Know About Our Services"
    //     const updateMetaTag = (name, content) => {
    //         let metaTag = document.querySelector(`meta[name="${name}"]`)
    //         if (metaTag) {
    //             metaTag.setAttribute('content', content)
    //         } else {
    //             metaTag = document.createElement('meta')
    //             metaTag.setAttribute('name', name)
    //             metaTag.setAttribute('content', content)
    //             document.head.appendChild(metaTag)
    //         }
    //     }
    //     updateMetaTag('description', "Explore answers to the most commonly asked questions about NannyGranny and feel confident in choosing the perfect care and support for your little ones every step of the way.")
    //     updateMetaTag('title', 'NannyGranny FAQs – Everything You Need To Know About Our Services')
    // },
    metaInfo() {
    return {
      title: 'NannyGranny FAQs – Everything You Need To Know About Our Services',
      meta: [
        {
          name: 'description',
          content: 'Explore answers to the most commonly asked questions about NannyGranny and feel confident in choosing the perfect care and support for your little ones every step of the way.'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: window.location.href
        }
      ]
    }
  },
    computed: {
        items() {
            return this.$store.getters['page/content']('faqs')
                .filter(item => item.slug === `${this.selectedRole}_item`)
        }
    }
}
</script>

<style lang="stylus" scoped>
._faqs-layout
  padding-bottom 150px

.faq-header
  display flex
  justify-content space-between
  align-items flex-start
  margin-bottom 10px

.back-btn
  font-size 16px
  font-weight bold
  color #555
  padding 6px 12px
  border-radius 6px
  cursor pointer

.chat-info
  text-align right
  font-size 14px
  line-height 1.4
  display flex
  flex-direction column
  align-items flex-end
  gap 5px

.chat-info strong
  font-weight bold

.chat-icon
  width 320px
  height 190px
  cursor pointer

.faq-heading
  margin-left 160px
  font-size 48px
  margin-bottom 20px

.toggle-buttons
  display flex
  justify-content center
  gap 20px
  margin-bottom 30px

.toggle-buttons button
  background-color transparent
  color #4D4DFF
  padding 10px 20px
  border-radius 30px
  font-weight 600
  cursor pointer
  transition all 0.3s

.toggle-buttons button.active
  background-color #2196f3
  color white

@media (min-width : 320px)  and (max-width: 480px)
    .faq-heading
        margin-left 60px
        font-size 36px
        margin-bottom 40px
    .chat-info
        text-align right
        font-size 8px
        

    .chat-info strong
        font-weight bold
</style>



// WEBPACK FOOTER //
// src/views/content/faqs/index.vue